/** @format */

import axios from "axios";
import serverAPI from "../config/ServerApi";

const setAuthToken = (token: string | null): void => {
  if (token) {
    serverAPI.defaults.headers.common["authorization"] = `Bearer ${token}`;
  } else {
    delete serverAPI.defaults.headers.common["authorization"];
    delete axios.defaults.headers.common["authorization"];
  }
};

export default setAuthToken;
